import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CategoriaPermissaoListarComponent } from './categoria-permissao-listar.component';

@NgModule({
  imports: [RouterModule.forChild([
    {path:'', component: CategoriaPermissaoListarComponent}
  ])],
  exports: [RouterModule]
})
export class CategoriaPermissaoListarRoutingModule { }
